import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { documentTypeApi } from '../../utilities/api';
import { DocumentType } from '../../utilities/interfaces/DocumentType';

interface documentTypeState {
  documentTypes: DocumentType[];
}

const initialState: documentTypeState = {
  documentTypes: [],
};

const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDocumentTypes.fulfilled, (state, action: any) => {
      state.documentTypes = action.payload;
    });
  },
});

export const getDocumentTypes = createAsyncThunk('stateDocumentType/getDocumentTypes', async () => {
  const response = await documentTypeApi.get();
  return response;
});

export default documentTypeSlice.reducer;
